import React from 'react';

// theme
import aampeTheme from '../../../constants/aampeTheme';

// components
import BasicChip from './basicChip';

interface BasicChipsListProps {
    items: { id: number | string; name: string }[];
    onClickHandler?: (id: number | string) => void;
    style?: React.CSSProperties;
    chipStyle?: React.CSSProperties;
}

const BasicChipsList: React.FC<React.PropsWithChildren<BasicChipsListProps>> =
    ({ items, onClickHandler, style, chipStyle }) => {
        return (
            <div
                style={{
                    width: 'fit-content',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '10px',
                    marginTop: aampeTheme.spacing4(6),
                    ...style,
                }}
            >
                {items?.map((item) => (
                    <BasicChip
                        key={item.id}
                        title={item.name}
                        onClickHandler={
                            onClickHandler && (() => onClickHandler(item.id))
                        }
                        style={chipStyle}
                    />
                ))}
            </div>
        );
    };

export default BasicChipsList;
